import { Container } from "react-bootstrap";
import Loader from "../Loader";

const LoaderWrapper = () => (
  <Container className="my-2 MainContent">
    <Loader />
  </Container>
);
export default LoaderWrapper;
